module.exports = __webpack_public_path__ + "static/media/galerija_2017 (17).f7b7e694.jpg";